export default __webpack_public_path__ + "static/media/iconSairCompartilhamento.fb2fdc01.svg";